
export default function Rollback({rollback}) {
    return async ({ keys }) => {
        rollback(keys)
    }
}